import { render, staticRenderFns } from "./GlobalError.vue?vue&type=template&id=43276f86&"
import script from "./GlobalError.vue?vue&type=script&lang=js&"
export * from "./GlobalError.vue?vue&type=script&lang=js&"
import style0 from "./GlobalError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports